var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluelogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#163E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6665 14.6667C28.6665 18.3486 25.6816 21.3333 21.9998 21.3333C18.3179 21.3333 15.333 18.3486 15.333 14.6667C15.333 10.9849 18.3179 8 21.9998 8C25.6816 8 28.6665 10.9849 28.6665 14.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 24H16.3333C12.8413 24 10 26.8413 10 30.3333V35C10 35.552 10.448 36 11 36H33C33.552 36 34 35.552 34 35V30.3333C34 26.8413 31.1587 24 27.6667 24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6816 19.2666L37.0149 14.9333C36.8269 14.7585 36.5815 14.668 36.335 14.668C35.6736 14.668 35.3335 15.2307 35.3335 15.6667V18.6667H30.0002C29.2629 18.6667 28.667 19.2639 28.667 20C28.667 20.7361 29.2629 21.3333 30.0002 21.3333H35.3335V24.3333C35.3335 24.8879 35.7842 25.3333 36.3335 25.3333C36.5815 25.3333 36.8257 25.2415 37.0149 25.0667L41.6816 20.7334C41.8843 20.5439 42.0002 20.2773 42.0002 20C42.0002 19.7227 41.8843 19.4561 41.6816 19.2666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluelogout);
export default __webpack_public_path__ + "static/media/bluelogout.407e203548727257899e85ca7b789c30.svg";
export { ForwardRef as ReactComponent };